/**
 * For use with PageHeader. Adds a 'request bespoke report' action to page
 * header, which brings up a modal with a form. The form adds the user to a
 * AC list and logs their request as an AC 'note'. This is chosen over a
 * custom field so that the request is not overwritten if submitted again
 * (and is more long-form friendly).
 *
 * @link https://browsergroup.atlassian.net/secure/RapidBoard.jspa?rapidView=24&view=planning&selectedIssue=GCD-6
 */
import React, { Fragment } from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, branch, withProps, withHandlers, setDisplayName } from 'recompose';
import { createSelector } from 'reselect';
import SubHeader from 'components/general/SubHeader/SubHeader';
import FormBuilder from 'components/forms/FormBuilder/FormBuilder';
import getUserData from 'state/selectors/getUserData';
import getUserAbility from 'state/selectors/getUserAbility';

const getInitialValues = createSelector(
  getUserData,
  R.applySpec({
    email: R.prop('email'),
  }),
);

const BespokeRequestForm = setDisplayName('BespokeRequestForm')(compose(
  connect(R.applySpec({
    initialValues: getInitialValues,
  })),
  withHandlers({}),
  withProps({
    event: 'Requested to Speak to S-RM',
    hideOnSubmit: true,
    submitLabel: 'Send message',
    successMessage: 'Thanks for your request. We\'ll be in touch shortly.',
    fields: [
      {
        type: 'email',
        name: 'email',
        label: 'Email',
        required: true,
        hidden: true,
      },
      {
        type: 'textArea',
        name: 'request',
        label: 'Request',
        hideLabel: true,
        required: true,
        rows: 10,
      },
    ],
  }),
)(FormBuilder));

const withQuoteCTA = () => compose(
  connect(R.applySpec({
    ability: getUserAbility,
  })),
  branch(
    ({ ability }) => ability.cannot('use', 'login') /* && ability.cannot('read', 'all') -- Hide for admins */,
    withProps(R.over(
      R.lensProp('actions'),
      R.prepend({
        icon: 'send', 
        title: 'Speak to S-RM',
        types: ['accent'],
        onClick: () => window.location.href = 'mailto:GSI@s-rminform.com?subject=Speak to S-RM', // This should be replaced with the desired email address
        target: '_blank',
      }),
    )),
  ),
);

export default withQuoteCTA;
